import { WebRequest } from '@cgn/framework-ui-components/v1';

const exports = {
  tutteLePratiche(codiceUfficio) {
    return WebRequest.get('/Pratica/Tutte', { codiceUfficio });
  },

  praticheUfficio(codiceUfficio) {
    return WebRequest.get('/Pratica/Ufficio', { codiceUfficio });
  },

  archivio(codiceUfficio, anno) {
    return WebRequest.get('/Pratica/Archivio', { codiceUfficio, anno });
  },

  ricerca(studio, ricerca) {
    return WebRequest.get('/Pratica/PratichePaginate', {
      from: 0, size: 100, search: encodeURI(ricerca), codiceUfficio: studio,
    });
  },

  pratiche(codiceUfficio, anno, from, size) {
    return WebRequest.get('/Pratica/Pratiche', {
      codiceUfficio, anno, from, size,
    });
  },

  praticheRicerca(from, size, search, codiceUfficio) {
    return WebRequest.get('/Pratica/PratichePaginate', {
      from, size, search, codiceUfficio,
    });
  },

  pratica(codiceUfficio, idPratica) {
    return WebRequest.get('/Pratica/Pratica', { codiceUfficio, idPratica });
  },

  anniPratiche(codiceUfficio) {
    return WebRequest.get('/Pratica/AnniPratiche', { codiceUfficio });
  },

  conversazione(idPratica) {
    return WebRequest.get('/Pratica/Conversazione', { idPratica });
  },

  vota(idPratica, codiceUfficio, voto, commento) {
    return WebRequest.post('/Pratica/Vota', {
      Nome: window.NomeUtente, Cognome: window.CognomeUtente, Commento: commento, IdPratica: idPratica, IdUtente: codiceUfficio, Voto: voto,
    });
  },

  allegatiMessaggio(idMessaggio) {
    return WebRequest.get('/Pratica/AllegatiMessaggio', { idMessaggio });
  },

  eliminaAllegato(idAllegato, idPratica) {
    return WebRequest.post('/Pratica/EliminaAllegato', { IdAllegato: idAllegato, IdPratica: idPratica });
  },

  leggiConversazione(idPratica) {
    return WebRequest.get('/Pratica/LeggiConversazione', { idPratica });
  },

  canaliTematici() {
    return WebRequest.get('/Messaggi/CanaliTematici');
  },

  messaggi(idCanaleTematico, skip, take, filtraNonLetti, anno, storico = false) {
    return WebRequest.get('/Messaggi/Messaggi', {
      idCanaleTematico, skip, take, filtraNonLetti, anno, storico,
    });
  },

  messaggiNonLetti(accountId) {
    return WebRequest.get('/Messaggi/MessaggiNonLetti', { accountId });
  },

  anniMessaggi(accountId) {
    return WebRequest.get('/Messaggi/AnniMessaggi', { accountId });
  },

  numeroPraticheNonLette(codiceUfficio) {
    return WebRequest.get('Pratica/NumeroPraticheNonLette', { codiceUfficio });
  },

  numeroPraticheDaLeggere(codiceUfficio) {
    return WebRequest.get('Pratica/NumeroPraticheDaLeggere', { codiceUfficio });
  },

  segnaComeLette(idInvio) {
    return WebRequest.get('/Messaggi/SegnaComeLetto', { idInvio });
  },
};

export default exports;
